import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SubscriptionCardSkeleton } from "./subscriptionCardSkeleton.js";
const AccountSkeleton = ()=>/*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-subscription-list",
        "aria-busy": "true",
        "aria-live": "polite",
        "aria-label": "Loading subscriptions",
        children: [
            /*#__PURE__*/ _jsx(SubscriptionCardSkeleton, {
                isExpanded: true
            }),
            /*#__PURE__*/ _jsx(SubscriptionCardSkeleton, {}),
            /*#__PURE__*/ _jsx(SubscriptionCardSkeleton, {})
        ]
    });
export { AccountSkeleton };
